/**
 * DevExtreme (esm/ui/form/constants.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var WIDGET_CLASS = "dx-widget";
export var FORM_CLASS = "dx-form";
export var FORM_GROUP_CLASS = "dx-form-group";
export var FORM_GROUP_CAPTION_CLASS = "dx-form-group-caption";
export var FORM_FIELD_ITEM_COL_CLASS = "dx-col-";
export var FIELD_ITEM_CLASS = "dx-field-item";
export var LAYOUT_MANAGER_ONE_COLUMN = "dx-layout-manager-one-col";
export var FIELD_ITEM_LABEL_CONTENT_CLASS = "dx-field-item-label-content";
export var FORM_LAYOUT_MANAGER_CLASS = "dx-layout-manager";
export var FIELD_ITEM_LABEL_CLASS = "dx-field-item-label";
export var FIELD_ITEM_CONTENT_CLASS = "dx-field-item-content";
export var SINGLE_COLUMN_ITEM_CONTENT = "dx-single-column-item-content";
export var ROOT_SIMPLE_ITEM_CLASS = "dx-root-simple-item";
export var FORM_GROUP_CONTENT_CLASS = "dx-form-group-content";
export var FIELD_ITEM_CONTENT_HAS_GROUP_CLASS = "dx-field-item-has-group";
export var FIELD_ITEM_CONTENT_HAS_TABS_CLASS = "dx-field-item-has-tabs";
export var FORM_GROUP_WITH_CAPTION_CLASS = "dx-form-group-with-caption";
export var FIELD_ITEM_TAB_CLASS = "dx-field-item-tab";
export var GROUP_COL_COUNT_CLASS = "dx-group-colcount-";
export var GROUP_COL_COUNT_ATTR = "group-col-count";
export var FORM_VALIDATION_SUMMARY = "dx-form-validation-summary";
export var FORM_UNDERLINED_CLASS = "dx-form-styling-mode-underlined";
export var SIMPLE_ITEM_TYPE = "simple";
